exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".play__play__bW3Uj{box-sizing:border-box;-ms-flex-align:center;align-items:center}.play__play__bW3Uj .play__icon__1yPKz{opacity:.8;transition-property:opacity}.play__play__bW3Uj:hover .play__icon__1yPKz{opacity:1}.play__play--play__1SJBk .play__icon__1yPKz{font-size:17px}.play__play--pause__Hh_VX .play__icon__1yPKz{font-size:14px}.play__at-full-screen__2f1he.play__play--play__1SJBk .play__icon__1yPKz{font-size:24px}.play__at-full-screen__2f1he.play__play--pause__Hh_VX .play__icon__1yPKz{font-size:21px}", ""]);

// exports
exports.locals = {
	"play": "play__play__bW3Uj",
	"icon": "play__icon__1yPKz",
	"play--play": "play__play--play__1SJBk",
	"playPlay": "play__play--play__1SJBk",
	"play--pause": "play__play--pause__Hh_VX",
	"playPause": "play__play--pause__Hh_VX",
	"at-full-screen": "play__at-full-screen__2f1he",
	"atFullScreen": "play__at-full-screen__2f1he"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/controls/play/play.styl
// module id = 1305
// module chunks = 0 1 2 3